// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__11GAs","sendOtp":"AuthorizeToLogin_sendOtp__5Xfmo"};